import React, { Component } from 'react';
import Popover from '@mui/material/Popover';
import { WithStyles, withStyles } from '@mui/styles';
import APProfilePhoto from "../../atoms/APProfilePhoto";
import APButton from "../../atoms/APButton";
import APLabel from "../../atoms/APLabel";
import { withTranslate } from "../../../core/TenantProvider";
import APContactSectionStyles from "./styles/APContactSection.style";
import { connect } from 'react-redux';
import { ReducerState } from '../../../redux/modules';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from "../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags";

interface APContactSectionProps extends WithStyles<typeof APContactSectionStyles> {
  translate: Function,
  affiliateDetails: any,
}

interface ContactPullOutState {
  anchorEl: any,
}

class APContactSection extends Component<APContactSectionProps, ContactPullOutState, {}> {
  constructor(props: any) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  showContactPullOutPopover = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: event.currentTarget });
    TriggerGoogleAnalyticsTag(
      GoogleAnalyticTags.eventAction.click,
      GoogleAnalyticTags.menuClicks.click.contact
    );
    TriggerGoogleAnalytics4Tag(
      GoogleAnalytics4Tags.menuClicks.name,
      GoogleAnalytics4Tags.eventAction.click,
      GoogleAnalytics4Tags.menuClicks.click.contact
    );
  };

  closeContactPullOutPopover = (event: object, anchorEl: any) => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, translate, affiliateDetails } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const id = open ? 'contact-pullout-popover' : '';
    const sourceURL: string = affiliateDetails?.affiliate?.photoUrl;

    return (
      <div>
        <div className={classes.contactContainer}>
          <div className={classes.managerDetails}>
            <APProfilePhoto className={classes.managerPhoto} sourceURL={sourceURL} />
            <APLabel className={classes.managerName}>
              {affiliateDetails?.affiliate?.owner_first_name ? `${affiliateDetails?.affiliate?.owner_first_name} ` : ''}
              {affiliateDetails?.affiliate?.owner_last_name ? affiliateDetails?.affiliate?.owner_last_name : ''}
            </APLabel>
            <APLabel className={classes.managerTitle}>
              {translate("contact.affiliate.manager")}
            </APLabel>
            <APButton
              // to="/contact"
              variant="contained"
              className={classes.contactButton}
              onClick={this.showContactPullOutPopover}
              data-testid="PullOutPopover"
            >
              {translate("contact.action.contact")}
            </APButton>
          </div>
        </div>
        <div className={classes.contactPullOutWrapper}>
          <Popover
            style={{ zIndex: 1299 }}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={this.closeContactPullOutPopover}
            className={classes.contactPullOutContainer}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
          >
            <div className={classes.contactInfoSection}>
              <div className={classes.userContact}>
                <h6>{translate('contact.heading', {
                  first_name: affiliateDetails?.affiliate?.owner_first_name,
                  last_name: affiliateDetails?.affiliate?.owner_last_name
                })}
                </h6>
                <ul>
                  <li><span>{translate('contact.directline')}</span></li>
                  <li><span className={classes.userContactSource}>
                    {affiliateDetails?.affiliate?.owner_country_isdcode && affiliateDetails?.affiliate?.owner_phone_no ? (`+${affiliateDetails?.affiliate?.owner_country_isdcode}${affiliateDetails?.affiliate?.owner_phone_no}`) : ''}
                    {!affiliateDetails?.affiliate?.owner_country_isdcode ? affiliateDetails?.affiliate?.owner_phone_no ? `+${affiliateDetails?.affiliate?.owner_phone_no}` : '' : ''}
                  </span></li>

                  <li><span>{translate('contact.mobilenumber')}</span></li>
                  <li><span className={classes.userContactSource}> {affiliateDetails?.affiliate?.owner_mobile_no ? `${affiliateDetails?.affiliate?.owner_mobile_no}` : ''}</span></li>

                  <li><span>{translate('contact.email')}</span></li>
                  <li /*style="overflow-wrap: break-word" */><span className={classes.userContactSource}>{affiliateDetails?.affiliate?.owner_emailid ? `${affiliateDetails?.affiliate?.owner_emailid}` : ''}</span></li>
                </ul>
              </div>
              <div className={classes.teamContact}>
                <h6>{translate('contact.team.heading')}</h6>
                <ul>
                  <li><span>{translate('contact.team.call')}</span></li>
                  <li><span className={classes.teamContactSource}>{translate('contact.phone.number')}</span></li>

                  <li><span>{translate('contact.team.email')}</span></li>
                  <li><span className={classes.teamContactSource}>{translate('contact.email.address')}</span></li>
                </ul>
              </div>
            </div>
          </Popover>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store: ReducerState) => ({
  affiliateDetails: store.user.affiliateDetails,
});

export default connect(mapStateToProps)(
  withTranslate(withStyles(APContactSectionStyles)(APContactSection)
  ));
